import { MessageCircle, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { trackWhatsAppClick } from '@/lib/gtm';
import { buildWhatsAppLink } from '@/lib/leadUtils';
import { Link } from 'react-router-dom';

const WHATSAPP_NUMBER = '5562999094131';
const WHATSAPP_MESSAGE = 'Oi, tudo bem? Vim do site da Solari e gostaria de saber mais sobre seus kits de porta pronta';

const Header = () => {
  const handleWhatsAppClick = () => {
    trackWhatsAppClick('Header CTA');
    window.open(buildWhatsAppLink(WHATSAPP_NUMBER, WHATSAPP_MESSAGE), '_blank');
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <div className="container-custom flex h-16 items-center justify-between md:h-20">
        <Link to="/" className="flex items-center gap-2 transition-opacity hover:opacity-80" aria-label="Página inicial">
          <img src="/favicon-solari.png" alt="Solari Soluções para Construção" className="h-10 w-10 rounded-sm object-contain md:h-12 md:w-12" width={48} height={48} />
        </Link>

        <div className="flex items-center gap-2 md:gap-3">
          <Button
            onClick={handleWhatsAppClick}
            className="flex items-center gap-2 bg-primary px-3 py-2 font-heading text-sm font-semibold text-primary-foreground hover:bg-primary/90 md:px-5 md:text-base"
          >
            <MessageCircle className="h-4 w-4 md:h-5 md:w-5" />
            <span className="hidden sm:inline">Fale Conosco</span>
            <span className="sm:hidden">WhatsApp</span>
          </Button>
          <Link
            to="/login"
            className="flex items-center gap-1.5 rounded-md border border-border px-2.5 py-2 text-xs text-muted-foreground transition-colors hover:bg-muted hover:text-foreground md:text-sm"
            aria-label="Área restrita"
          >
            <Lock className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Área restrita</span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
